"use client";

import { useEffect, useMemo, useState } from "react";
import { useEcommerce } from "../EcommerceProvider/EcommerceProvider";
import "./style.css";

function looksLikeHtml(value: string) {
  return /<\/?[a-z][\s\S]*>/i.test(value);
}

export function Faq() {
  const ecommerce = useEcommerce();
  const faq = useMemo(() => ecommerce.faq ?? [], [ecommerce.faq]);

  const [answers, setAnswers] = useState<string[]>([]);

  useEffect(() => {
    if (!faq.length) {
      setAnswers([]);
      return;
    }

    let cancelled = false;

    (async () => {
      const createDOMPurify = (await import("dompurify")).default;
      const DOMPurify = createDOMPurify(window);

      const sanitized = faq.map((item) => {
        const raw = item.answer?.trim() ?? "";

        if (!raw) return "";

        if (!looksLikeHtml(raw)) {
          return raw;
        }

        const clean = DOMPurify.sanitize(raw, {
          ALLOWED_TAGS: ["p", "strong", "em", "br", "ul", "ol", "li", "a"],
          ALLOWED_ATTR: ["href", "target", "rel"],
        });

        return clean.replace(/<a\b([^>]*?)>/gi, (_m, attrs) => {
          const target = /target=/i.test(attrs) ? "" : ' target="_blank"';
          const rel = /rel=/i.test(attrs)
            ? ""
            : ' rel="noopener noreferrer nofollow"';
          return `<a${attrs}${target}${rel}>`;
        });
      });

      if (!cancelled) {
        setAnswers(sanitized);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [faq]);

  if (!faq.length) {
    return null;
  }

  return (
    <section className="faq-section">
      <h2 className="faq-title">Najczęściej zadawane pytania</h2>

      <div className="faq-list">
        {faq.map((item, index) => (
          <div key={index} className="faq-item">
            <h3 className="faq-question">{item.question}</h3>

            {looksLikeHtml(item.answer) ? (
              <div
                className="faq-answer"
                dangerouslySetInnerHTML={{ __html: answers[index] ?? "" }}
              />
            ) : (
              <p className="faq-answer">{answers[index]}</p>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
